export default "__VITE_ASSET__df6733f9__"